interface DiscountSaveButtonProps {
  type: 'deadline' | 'reservation';
  canSave: boolean;
  saving: boolean;
  selectedCount: number;
  onSave: () => void;
  isFloating?: boolean; // 모바일용 플로팅 옵션
}

export function DiscountSaveButton({
  type,
  canSave,
  saving,
  selectedCount,
  onSave,
  isFloating = false
}: DiscountSaveButtonProps) {
  const getButtonText = () => {
    if (saving) return '저장 중...';
    return `${type === 'deadline' ? '마감할인' : '예약할인'} 설정 저장`;
  };

  const getStatusText = () => {
    if (selectedCount === 0 && !canSave) {
      return `${type === 'deadline' ? '마감할인' : '예약할인'}으로 설정할 상품을 선택해주세요`;
    }
    return null;
  };

  if (isFloating) {
    // 모바일 플로팅 모드
    return (
      <div className="fixed bottom-20 left-0 right-0 z-40 bg-white border-t shadow-lg px-4 py-3">
        {/* 선택된 상품 수량 표시 */}
        {selectedCount > 0 && (
          <div className="flex items-center justify-center mb-3">
            <div className="flex items-center">
              <svg className="w-4 h-4 text-green-500 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-sm font-medium text-green-800">
                {selectedCount}개 상품 선택됨
              </span>
            </div>
          </div>
        )}

        {/* 저장 버튼 */}
        <button
          onClick={onSave}
          disabled={!canSave}
          className={`w-full py-3 rounded-lg font-medium transition-colors ${
            canSave
              ? 'bg-green-500 text-white hover:bg-green-600'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
        >
          {getButtonText()}
        </button>

        {/* 상태 메시지 */}
        {getStatusText() && (
          <p className="text-center text-xs text-gray-500 mt-2">
            {getStatusText()}
          </p>
        )}
      </div>
    );
  }

  // 일반 모드 (데스크톱 등)
  return (
    <div className="space-y-4">
      {/* 선택된 상품 요약 */}
      {selectedCount > 0 && (
        <div className="bg-green-50 border border-green-200 rounded-lg p-4">
          <div className="flex items-center">
            <svg className="w-5 h-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-sm font-medium text-green-800">
              {selectedCount}개 상품이 {type === 'deadline' ? '마감할인' : '예약할인'}으로 설정됩니다
            </span>
          </div>
        </div>
      )}

      {/* 저장 버튼 */}
      <button
        onClick={onSave}
        disabled={!canSave}
        className={`w-full py-3 rounded-lg font-medium transition-colors ${
          canSave
            ? 'bg-green-500 text-white hover:bg-green-600'
            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
        }`}
      >
        {getButtonText()}
      </button>

      {/* 상태 메시지 */}
      {getStatusText() && (
        <p className="text-center text-sm text-gray-500">
          {getStatusText()}
        </p>
      )}
    </div>
  );
}
